<template>
  <v-card>
    <DownloadHbsDialog ref="downloadDialog" />

    <v-toolbar class="card-bar">
      <v-toolbar-title>Input</v-toolbar-title>

      <v-btn icon @click="openExportDialog" class="ml-4">
        <v-icon>mdi-select-search</v-icon>
      </v-btn>

      <v-spacer />

      <label>FW Version (inicial):</label>
      <div style="width: 200px" class="pl-4">
        <v-text-field
          v-model="startFwVersion"
          label="Versão inicial do Firmware"
          single-line
          hide-details
          clearable
          class="pa-0"
          prefix="0x"
        />
      </div>

      <v-spacer />

      <v-btn icon>
        <v-icon>mdi-code-braces</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-information-outline</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-textarea
        rows="20"
        class="monospace-input"
        v-model="hexInput"
        label="Rawdata (hex)"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn large color="primary" @click="parse">
        Prosseguir para Output
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import DownloadHbsDialog from './DownloadHbsDialog.vue'
import InspectorStore from './InspectorStore'

export default {
  components: { DownloadHbsDialog },
  computed: {
    startFwVersion: {
      get() {
        return InspectorStore.startFwVersion
      },
      set(x) {
        InspectorStore.startFwVersion = x
      }
    },
    hexInput: {
      get() {
        return InspectorStore.hexInput
      },
      set(x) {
        InspectorStore.hexInput = x
      }
    }
  },
  methods: {
    parse() {
      try {
        InspectorStore.parse()
        this.$snack('Parseado com sucesso')
        this.$emit('gotoOutput')
      } catch (err) {
        this.$showErr(err)
      }
    },

    async openExportDialog() {
      const str = await this.$refs.downloadDialog.open()
      if (str != null && str.trim().length > 0) {
        this.hexInput = str
      }
    }
  }
}
</script>

<style></style>
